import ko from 'knockout';
import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { responsiveSearchModel } from './model/rsa-model';
import { improveResponsiveSearchModel } from './model/improve-rsa-model';
import { improveMultimediaModel } from './model/improve-mma-model';
import { multimediaModel, getImageFeatureMaskMap } from './model/mma-model';

export default class ViewModel {
  constructor({
    data,
    type,
  }) {
    switch (type) {
      case RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS:
        this.currentAdModel = ko.observable(responsiveSearchModel(data));
        break;
      case RECOMMENDATION_TYPES.MULTIMEDIA_ADS:
        this.imageFeatureMaskMap = getImageFeatureMaskMap(data);
        this.currentAdModel = ko.observable(multimediaModel(data));
        break;
      case RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS:
        this.currentAdModel = ko.observable(improveResponsiveSearchModel(data));
        break;
      case RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS:
        this.currentAdModel = ko.observable(improveMultimediaModel(data));
        break;
      default:
        break;
    }
  }
}
